<template>
    <div class="page">
        <img class="welcome-img" style="width:40%;" src="~@/assets/logo.png" />
        <img class="welcome-img" src="~@/assets/prizes.png" />
        <img class="welcome-img" src="~@/assets/dailyweekly.png" />
        <img class="continue-btn" src="~@/assets/continue.png" @click="goto" />
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Welcome',
    data(){
        return {
        }
    },
    computed: {
        ...mapState(['userInfo','lang','langMap'])
    },
    created(){
    },
    methods: {
        goto(){
            window.location.href = this.$parent.baseHomeUrl;
        }
    }
}
</script>

<style lang="scss" scoped>
    .page{
        color: #fff;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: url('~@/assets/wel-bg.jpg') top center/cover repeat-y fixed;
        overflow:scroll;
    }
    .continue-btn{
        width: 45%;
        display:block;margin-left:auto;margin-right:auto;
    }
    .welcome-img{
        display:block;margin-left:auto;margin-right:auto;width:100%;
    }
    @media screen and (max-width : 360px){
        .continue-btn{
            width: 45%;
            display:block;margin-left:auto;margin-right:auto;
        }
        .welcome-img{
            display:block;margin-left:auto;margin-right:auto;width:75%;
    }
    }
</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue